import { IconProps } from "@design-system/types";

export function ColoredInvestmentIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22 12.6667L16.4 18.2667L14.2667 15.0667L10 19.3333"
        stroke="#0046BB"
        strokeWidth="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M19.3335 12.6667H22.0002V15.3333"
        stroke="#0046BB"
        strokeWidth="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.9998 29.3333H19.9998C26.6665 29.3333 29.3332 26.6667 29.3332 20V12C29.3332 5.33332 26.6665 2.66666 19.9998 2.66666H11.9998C5.33317 2.66666 2.6665 5.33332 2.6665 12V20C2.6665 26.6667 5.33317 29.3333 11.9998 29.3333Z"
        stroke="#0046BB"
        strokeWidth="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
